export const FETCH_SERVICES = 'FETCH_SERVICES';
export const CLEAN_REDUCER = 'CLEAN_REDUCER';
export const FETCH_COUNTRIES = 'FETCH_COUNTRIES';
export const FETCH_COMPANY_COUNTRIES = 'FETCH_COMPANY_COUNTRIES';
